'use client';
import React from 'react';
import { Box, Stack } from '@mui/material';
import ParallaxText from '@components/ParallaxText';
import ReactHtmlParser from '@libs/reactHtmlParser';
import DynamicButton from '@components/DynamicButton';
import CommonContainer from '@components/CommonContainer';
import cn from './style.module.scss';

export default function WharfBanner(props: any) {
  const { ransomBannerHeading, ransomBannerLabel = [] } =
    props.locale?.section ?? {};

  return (
    <Stack component="section" className={cn.wharfBannerWrapper}>
      <Box className={cn.wharfBannerInner}>
        <CommonContainer maxWidth={{ xs: '100%', md: '1440px' }} flexGrow={1}>
          <Box className={cn.wharfBannerBlock}>
            <ParallaxText
              variant="h2"
              animationType="zoomIn"
              animationDuration={500}
            >
              {ReactHtmlParser(props.locale.section['ransomBannerHeading'])}
            </ParallaxText>
          </Box>
          <Box className={cn.wharfBannerButton}>
            <DynamicButton
              className={cn.bannerButtonElement}
              children={props.locale.section['ransomButton']}
              scrollToId="wharfRegistrationID"
            />
          </Box>
          {Array.isArray(ransomBannerLabel) && ransomBannerLabel.length > 0 && (
            <ul className={cn.wharfBannerTags}>
              {ransomBannerLabel.map((item) => (
                <li key={item.id}>{item.label}</li>
              ))}
            </ul>
          )}
        </CommonContainer>
      </Box>
    </Stack>
  );
}
